export const IN_NUM = (num) => {return {type: 'IN_NUM',}}